import type { Container } from 'pixi.js';

export const setRelativePosition = (
  view: Container,
  percentX: number,
  percentY: number,
  x: number,
  y: number,
): void => {
  view.x = x + (percentX * window.innerWidth) / 100;
  view.y = y + (percentY * window.innerHeight) / 100;
};
